/* eslint-disable no-console */
import { isDevelopment, isUAT } from "constants/internal"
import { isLocalhost } from "registerServiceWorker"

export const logError = (...params) => {
    if (isDevelopment || isUAT || isLocalhost) {
        console.error(...params)
    }
}
